//
// Reel class
//
// Used to create, spin and animate reels
// Contains no logic.
// Set up reels as follows:
//
//    1 - reelmanager.createReel
//    2 - reelmanager.setSymbol to change initial symbols
//
// To use
//
//    1 - Set data using reelmanager.setData(arrayOfSymbolIndexes)
//    2 - reelmanager.startSpin()
//
//

reelTemplate = {};

reelTemplate.accelerationSpin = function (delta) {
  // Calculate new speed based on acceleration
  this.pos -= (delta / 1000) * this.speedData.currentAccelerationSpeed;
  this.speedData.currentAccelerationSpeed +=
    this.speedData.accelerationRate * (delta / 1000);

  return Math.floor(
    this.speedData.currentAccelerationSpeed >= this.spinParams.spinSpeed
  );
};

reelTemplate.decelerationSpin = function (delta) {
  // Calculate new speed based on acceleration
  this.speedData.decelerationRate =
    (this.speedData.currentDecelerationSpeed *
      this.speedData.currentDecelerationSpeed) /
    (2 * (this.pos - (1 - this.spinParams.landOffset)));
  this.pos -= (delta / 1000) * this.speedData.currentDecelerationSpeed;
  this.speedData.currentDecelerationSpeed -=
    this.speedData.decelerationRate * (delta / 1000);

  // We add 0.01 as position approaches 0 but will never reach it. This allows us to end spin when it's within 1/100th of a symbol height.
  return Math.floor(
    this.pos <= 1 - this.spinParams.landOffset + 0.01 ||
      this.speedData.currentDecelerationSpeed < this.spinParams.landVelocity
  );
};

reelTemplate.defaultSpin = function (delta) {
  this.pos -= (delta / 1000) * this.spinParams.spinSpeed;
  return Math.floor(
    this.pos <
      1 + this.spinParams.decelerationDistance - this.spinParams.landOffset
  );
};

reelTemplate.getDefaultConfigParameters = function () {
  var params = {};
  params.appertureHeight = 3;

  return params;
};

reelTemplate.getDefaultSpinParameters = function () {
  var params = {};

  // Acceleration and deceleration unit is "number of symbols"
  params.accelerationDistance = 0;
  params.decelerationDistance = 0;

  // Spin speed and land velocity are in symbols per second
  params.spinSpeed = 9;
  params.landVelocity = 0;

  // Land sound
  params.landSound = undefined;

  // Post land animation
  params.landOffset = 0.25;
  params.landAlignTime = 250;

  return params;
};

reelTemplate.setSpinParameters = function (params, json) {
  params.spinSpeed = json.spinSpeed || params.spinSpeed;
  params.landVelocity =
    typeof json.landVelocity !== "undefined"
      ? json.landVelocity
      : params.landVelocity;
  params.accelerationDistance =
    typeof json.accelerationDistance !== "undefined"
      ? json.accelerationDistance
      : params.accelerationDistance;
  params.decelerationDistance =
    typeof json.decelerationDistance !== "undefined"
      ? json.decelerationDistance
      : params.decelerationDistance;
  params.landOffset =
    typeof json.landOffset !== "undefined"
      ? json.landOffset
      : params.landOffset;
  params.landAlignTime =
    typeof json.landAlignTime !== "undefined"
      ? json.landAlignTime
      : params.landAlignTime;
  params.landSound = json.landSound || params.landSound;

  if (Reflex.developerModeData.fastSpin) {
    params.spinSpeed = 9999;
    params.accelerationDistance = 0;
    params.decelerationDistance = 0;
    params.landAlignTime = 50;
  }

  return params;
};

reelTemplate.createReel = function (reelIndex, json) {
  // Create reel object
  var reel = new PIXI.Container();

  // The symbols template tells us all about the reel symbols
  var symbolTemplate = resourceManager.getConfiguration().symbols;
  var keys = Object.keys(symbolTemplate);

  // Create spin parameters used for this reel (can change)
  reel.spinParams = reelTemplate.setSpinParameters(
    reelTemplate.getDefaultSpinParameters(),
    json
  );

  // Get configuration parameters used for this template (cant change)
  reel.configParams = reelTemplate.getDefaultConfigParameters();
  if (typeof json.appertureHeight !== "undefined") {
    reel.configParams.appertureHeight = json.appertureHeight;
  }

  var symbolTextures = textureParser.getTextureList("staticSymbols");
  var initialSymbols = [];
  for (var i = 0; i < reel.configParams.appertureHeight + 1; i++) {
    initialSymbols.push(0);
  }

  // Create object to store all speed parameters neatly
  reel.speedData = {};
  reel.symbolLUT = {};

  // Create look up table
  for (var i = 0; i < keys.length; i++) {
    var symbolDef = symbolTemplate[keys[i]];
    var textureTemplate =
      resourceManager.getConfiguration().textureLists[symbolDef.texture];
    reel.symbolLUT["ID" + symbolDef.ID] = i;
  }

  reel.setSpinParameters = function (spinParameters) {
    // spin Parameters should be passed as an object
    reelTemplate.setSpinParameters(this.spinParams, spinParameters);
  };

  reel.spinLandedCallback = function () {};
  reel.spinCompleteCallback = function () {};
  reel.Props = {};

  reel.Props.state = "READY";
  reel.Props.stateTime = 0;

  // Create data
  reel.symbolWidth = symbolTextures[0].width;
  reel.symbolHeight = symbolTextures[0].height;

  // These sizes are in standard layout space
  reelManager.symbolWidth =
    symbolTextures[0].width *
    resourceManager.selectedAssetResolution.scaleFactor;
  reelManager.symbolHeight =
    symbolTextures[0].height *
    resourceManager.selectedAssetResolution.scaleFactor;

  if (typeof json.appertureSpacing !== "undefined") {
    reel.configParams.appertureSpacing = json.appertureSpacing;
  } else {
    // Apperture spacing is not defined, so use symbol height as default
    reel.configParams.appertureSpacing = reel.symbolHeight;
  }

  reel.symbolContainer = new PIXI.Container();
  reel.addChild(reel.symbolContainer);
  reel.symbolData = [];
  reel.symbolSprites = [];

  reel.reelIndex = reelIndex;
  reel.spinning = false;
  reel.pos = 0;
  reel.preDelay = 0;

  reel.linkedAnimations = [];
  reel.linkedReelBoxStrips = [];

  // Set up background
  if (typeof json.backgroundColour !== "undefined") {
    reel.backgroundFill = new PIXI.Graphics();
    reel.backgroundFill.beginFill(json.backgroundColour, 1);
    reel.backgroundFill.drawRect(
      0,
      0,
      reel.symbolWidth,
      reel.symbolHeight * reel.configParams.appertureHeight
    );
    reel.backgroundFill.endFill();
    reel.addChildAt(reel.backgroundFill, 0);
  }

  reel.symbolSize = [];
  for (var i = 0; i < reel.configParams.appertureHeight + 1; i++) {
    var symbol = standardObjectFactory.createMovie(
      { definition: "staticSymbols" },
      true
    );
    symbol.anchor.set(0.5, 0.5);
    symbol.gotoAndStop(initialSymbols[i]);
    symbol.position.x = reel.symbolWidth / 2;
    symbol.position.y = (i + 0.5) * reel.configParams.appertureSpacing;
    reel.symbolData.push(initialSymbols[i]);
    reel.symbolContainer.addChild(symbol);
    reel.symbolSprites.push(symbol);
    symbol.symbolIndex = i;
    symbol.parentReel = reel;

    // Confirm all files loaded
    for (var j = 0; j < symbol.textures.length; j++) {
      if (!symbol.textures[j].baseTexture.hasLoaded) {
        console.log(
          "Texture index " +
            j +
            " for symbol " +
            Object.keys(resourceManager.getConfiguration().symbols)[j] +
            " was not loaded"
        );
        return;
      }
    }

    // Store original UV'. We only do this for the first symbol in the animation movie, as this is the one we spin past.
    if (i === 0) {
      for (var j = 0; j < symbol.textures.length; j++) {
        reel.symbolSize.push({
          width: symbol.textures[j].frame.width,
          height: symbol.textures[j].frame.height,
        });
      }
    }
  }

  reel.onTouched = function () {
    this.touchedCallback(this.parentReel.reelIndex, this.symbolIndex);
  };

  reel.setTouchCallback = function (index, callback) {
    reel.symbolSprites[index].interactive = true;
    reel.symbolSprites[index].mousedown = reel.symbolSprites[index].touchstart =
      reel.onTouched;
    reel.symbolSprites[index].touchedCallback = callback;
  };

  reel.clearTouchCallback = function (index) {
    reel.symbolSprites[index].interactive = false;
  };

  reel.setSymbolClip = function (symbolIndex, left, right, top, bottom) {
    // All values are normalised
    var symbol = this.symbolSprites[symbolIndex];
    for (var i = 0; i < symbol.textures.length; i++) {
      var width = reel.symbolSize[i].width;
      var height = reel.symbolSize[i].height;
      symbol.textures[i].frame = new PIXI.Rectangle(
        0,
        top * height,
        width,
        bottom * height - top * height
      );
    }
  };
  // Hide bottom symbol by default
  reel.setSymbolClip(reel.configParams.appertureHeight, 0, 0, 0, 0);

  reel.setReelSymbol = function (index, symbol) {
    // Overides data and sets symbol
    this.symbolData[index] = symbol;
    this.updateSymbols();
  };

  reel.initialise = function () {};

  reel.showSymbol = function (index, show) {
    this.symbolSprites[index].visible = show;
  };

  reel.setSpinner = function (spinnerFunction) {
    this.updatePos = spinnerFunction;
  };

  reel.startSpin = function (preDelay) {
    this.spinning = true;
    this.Props.state = "PRE_DELAY";
    this.Props.stateTime = this.preDelay;
    this.speedData.accelerationRate =
      (this.spinParams.spinSpeed * this.spinParams.spinSpeed) /
      (2 * this.spinParams.accelerationDistance);
    this.speedData.currentAccelerationSpeed = 0;
    this.speedData.currentDecelerationSpeed = this.spinParams.spinSpeed;
  };

  reel.dimAllSymbols = function (dim) {
    for (var i = 0; i < reel.configParams.appertureHeight + 1; i++) {
      //this.symbolSprites[i].alpha = dim ? 0.7 : 1.0;
      this.symbolSprites[i].tint = dim ? 0x777777 : 0xffffff;
    }
  };

  reel.setData = function (data) {
    if (
      data.length <
      this.spinParams.accelerationDistance +
        this.spinParams.decelerationDistance
    ) {
      console.log(
        "When trying to set up spin data, only " +
          data.length +
          " symbols were passed"
      );
      console.log(
        "The minimum is " +
          (this.spinParams.accelerationDistance +
            this.spinParams.decelerationDistance) +
          "symbols (acceleration distance of " +
          this.spinParams.accelerationDistance +
          " + deceleration distance of " +
          this.spinParams.decelerationDistance +
          ")"
      );
      return;
    }

    // Deep copy
    this.symbolData = [];
    for (var i = 0; i < data.length; i++) {
      var index = reel.symbolLUT["ID" + data[i]];
      if (typeof index === "undefined") {
        console.log("Symbol ID " + data[i] + " not defined for this reel.");
      } else {
        this.symbolData.push(index);
      }
    }

    this.pos = this.symbolData.length - this.configParams.appertureHeight - 1;

    this.updateSymbols();
  };

  reel.linkAnimation = function (animatiomStripID) {
    reel.linkedAnimations.push(animatiomStripID);
  };

  reel.linkReelBoxStrip = function (animatiomStripID) {
    reel.linkedReelBoxStrips.push(animatiomStripID);
  };

  reel.updateSymbols = function () {
    // Set symbols

    var index = Math.floor(this.pos);
    for (var i = 0; i < this.configParams.appertureHeight + 1; i++) {
      this.symbolSprites[i].gotoAndStop(this.symbolData[index + i]);
    }

    // Top symbol clipping
    var symbolIndex = this.symbolData[index];
    var textureHeightTop = reel.symbolSize[symbolIndex].height;
    // Clip needs to be normalised into "Symbol height" space not "apperture spacing" space
    var clip = 1 - (this.pos - index);
    var gain = textureHeightTop / reel.configParams.appertureSpacing;
    var offset = (1 - gain) / 2;
    clip = Math.max(0, Math.min(1, (clip - offset) / gain));
    this.setSymbolClip(0, 0, 1, 1 - clip, 1);
    this.symbolSprites[0].height = textureHeightTop * clip;
    this.symbolSprites[0].position.y =
      reel.configParams.appertureSpacing * 0.5 +
      (textureHeightTop * (1 - clip)) / 2;

    // Bottom symbol clipping
    symbolIndex = this.symbolData[index + this.configParams.appertureHeight];
    var textureHeightBottom = reel.symbolSize[symbolIndex].height;
    clip = 1 - (this.pos - index);
    var gain = textureHeightBottom / reel.configParams.appertureSpacing;
    offset = (1 - gain) / 2;
    clip = Math.max(0, Math.min(1, (clip - offset) / gain));
    this.setSymbolClip(this.configParams.appertureHeight, 0, 1, 0, 1 - clip);
    this.symbolSprites[this.configParams.appertureHeight].height =
      textureHeightBottom * (1 - clip);
    this.symbolSprites[this.configParams.appertureHeight].position.y =
      reel.configParams.appertureSpacing *
        (this.configParams.appertureHeight + 0.5) -
      (textureHeightBottom * clip) / 2;

    // Move container
    this.symbolContainer.position.y = -(
      (this.pos - index) *
      reel.configParams.appertureSpacing
    );
  };

  reel.update = reelTemplate.update;
  this.updatePos = reelTemplate.defaultSpin;
  return reel;
};

reelTemplate.update = function (delta) {
  this.Props.stateTime -= delta;
  switch (this.Props.state) {
    case "READY":
      {
      }
      break;

    case "PRE_DELAY":
      {
        if (this.Props.stateTime <= 0) {
          if (this.spinParams.accelerationDistance > 0) {
            this.updatePos = reelTemplate.accelerationSpin;
            this.Props.state = "ACCELERATING";
          } else {
            this.updatePos = reelTemplate.defaultSpin;
            this.Props.state = "SPINNING";
          }
        }
      }
      break;

    case "ACCELERATING":
      {
        if (this.updatePos(delta)) {
          this.Props.state = "SPINNING";
          this.updatePos = reelTemplate.defaultSpin;
        }

        this.updateSymbols();
      }
      break;

    case "SPINNING":
      {
        if (this.updatePos(delta)) {
          this.updatePos = reelTemplate.decelerationSpin;
          if (this.pos < 1 - this.spinParams.landOffset) {
            this.pos = 1 - this.spinParams.landOffset;
          }
          this.Props.state =
            this.spinParams.decelerationDistance > 0
              ? "DECELERATING"
              : "JUST_LANDED";
        }
        this.updateSymbols();
      }
      break;

    case "DECELERATING":
      {
        if (this.updatePos(delta)) {
          this.pos = 1 - this.spinParams.landOffset;
          this.Props.state = "JUST_LANDED";
        }
        this.updateSymbols();
      }
      break;

    case "JUST_LANDED":
      {
        if (
          Reflex.developerModeData.disableReelLandSound === false &&
          this.spinParams.landSound
        ) {
          soundManager.play(this.spinParams.landSound);
        }

        this.speedData.currentDecelerationSpeed = this.spinParams.landVelocity;
        this.Props.stateTime = this.spinParams.landAlignTime;
        this.spinLandedCallback(this.reelIndex);
        this.pos = 1 - this.spinParams.landOffset;
        this.updateSymbols();
        this.Props.state =
          this.spinParams.landOffset === 0 ? "SPIN_COMPLETE" : "PULL_BACK";
      }
      break;

    case "PULL_BACK":
      {
        if (this.Props.stateTime <= 0) {
          this.pos = 1;
          this.Props.state = "SPIN_COMPLETE";
        } else {
          var progress = this.Props.stateTime / this.spinParams.landAlignTime;
          this.pos = 1 - progress * this.spinParams.landOffset;
        }

        this.updateSymbols();
      }
      break;

    case "SPIN_COMPLETE":
      {
        // Reel landed
        this.pos = 1;
        this.updateSymbols();

        this.Props.state = "READY";
        this.spinning = false;
        this.spinCompleteCallback(this.reelIndex);
      }
      break;
  }
};
